// extracted by mini-css-extract-plugin
export var cardLayout = "_8v-1";
export var paginationContainer = "_8v-0";